class VariablePriceEntity {
}

export { VariablePriceEntity };
//# sourceMappingURL=varuablePrice.entity.js.map
